<template>
    <div></div>
</template>

<script>
    import { WidgetHelper } from '@bryntum/scheduler';

    import { eventBus } from '../../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props : {

            text : {type : String, default : 'Textfield'}

        },
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted() {

            var props = this.$props;


            const button = WidgetHelper.createWidget({
                type                    : 'textfield',
                appendTo                : this.$el,
                ref                     : 'filterByName',
                icon                    : 'b-fa b-fa-filter',
                cls                     : 'b-bright',
                placeholder             : 'Filter duties by name(s)',
                clearable               : true,
                keyStrokeChangeDelay    : 100,
                width                   : '100%',
                triggers                : {
                    filter              : {
                        align : 'start',
                        cls   : 'b-fa b-fa-filter'
                    }
                },
                onChange({ value }) {

                    eventBus.$emit('filter', value);

                } // eo function onChange()
            });

        } // eo function mounted()
        /* <<< ****************************************************************/

    };
</script>
